import {ZodObject, ZodTypeAny} from 'zod';
import {ToolExecuteParams, ToolResult} from '../../copilot.types';

export default function tool<
  TInputSchema extends ZodTypeAny = ZodObject<Record<string, never>>,
  TAgentScratchpadState = Record<string, unknown>,
>({
  name,
  displayName,
  description,
  inputSchema,
  execute,
  isReadonly = false,
}: {
  name: string;
  displayName: string;
  description: string;
  inputSchema: TInputSchema;
  execute: (params: ToolExecuteParams<TInputSchema, TAgentScratchpadState>) => Promise<ToolResult>;
  isReadonly?: boolean;
}) {
  return {
    name,
    displayName,
    description,
    execute,
    inputSchema,
    isReadonly,
  };
}
